// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3IZf4","label":"Completed_label__1uHNw"};